import { render, staticRenderFns } from "./sfc-resident-benefits.vue?vue&type=template&id=1d4584c8&scoped=true&lang=pug&"
import script from "./sfc-resident-benefits.vue?vue&type=script&lang=js&"
export * from "./sfc-resident-benefits.vue?vue&type=script&lang=js&"
import style0 from "./sfc-resident-benefits.vue?vue&type=style&index=0&id=1d4584c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4584c8",
  null
  
)

export default component.exports